import axios from "axios";
import { getServiceURL } from "../url";
import { UserType } from "@/types/baseTypes";
import { fetchFromVolatileServer } from "../fetchFromVolatileServer";
export const createUser = async (userData: UserType, locale?: string) => {
  return await axios.post(`${getServiceURL(locale)}/user`, { ...userData });
};

/* jscpd:ignore-start */
export const authenticateUser = async (userData: UserType, locale?: string) => {
  return await axios.post(
    `${getServiceURL(locale)}/auth/session`,
    { ...userData },
    {
      withCredentials: true,
    },
  );
};

export const logoutUser = async (locale?: string) => {
  // TODO handle Error properly
  return await axios
    .get(`${getServiceURL(locale)}/auth/session/logout`, {
      withCredentials: true,
    })
    .catch((err) => {
      console.error(err);
    });
};

export const fetchUser = async (
  cookie?: string | undefined,
  locale?: string,
) => {
  const ssrCookie = cookie ? { Cookie: cookie } : undefined;
  return await axios
    .get(`${getServiceURL(locale)}/user/me`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        ...ssrCookie,
      },
    })
    .then((res) => res)
    .catch(() => null);
};

export const verifyUser = async (cookie?: string, locale?: string) => {
  const ssrCookie = cookie ? { Cookie: cookie } : undefined;

  return await axios
    .get(`${getServiceURL(locale)}/auth/session/verify`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        ...ssrCookie,
      },
    })
    .then((res) => res)
    .catch((err) => err);
};

export interface FavoriteRecipesReturn {
  id: number;
  recipe: number;
  user: number;
}

export async function getFavorite(
  id: string | number,
  locale?: string,
): Promise<FavoriteRecipesReturn[]> {
  const url = `${getServiceURL(locale)}/user/${id}/favoriterecipe`;
  return fetchFromVolatileServer(`${url}`, {
    method: "GET",
    credentials: "include",
  })
    .then((res) => {
      if (!res.ok) {
        console.error("Response not ok for", url, res.status);
        throw new Error("Response not ok");
      }
      return res.json();
    })
    .catch((err) => {
      console.error(err);
      return null;
    });
}
export async function updateUser(user: UserType, locale?: string) {
  const url = `${getServiceURL(locale)}/user/${user.id}`;
  return fetchFromVolatileServer(`${url}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((res) => {
      if (!res.ok) {
        console.error("Response not ok for", url, res.status);
        throw new Error("Response not ok");
      }
      return res.json();
    })
    .catch((err) => {
      console.error(err);
      return null;
    });
}

export async function deleteUser(locale?: string) {
  try {
    const user = await fetchUser(undefined, locale);
    return (
      user &&
      fetchFromVolatileServer(`${getServiceURL(locale)}/user/${user.data.id}`, {
        method: "DELETE",
        credentials: "include",
      }).then((res) => {
        if (!res.ok) {
          console.error(res.status);
          throw new Error("Response not ok");
        }
        return res;
      })
    );
  } catch (err) {
    console.error(err);
    throw new Error("Deletion failed");
  }
}

export async function confirmDeleteUser(
  token: string,
  user: UserType,
  locale?: string,
) {
  try {
    return await fetchFromVolatileServer(
      `${getServiceURL(locale)}/user/${
        user.id
      }/deletion/verification?verificationCode=${token}`,
    ).then((res) => {
      if (!res.ok) {
        console.error(res.status);
        return new Error("Response not ok");
      }
      return res;
    });
  } catch (e) {
    console.error(e);
    return new Error("Deletion failed");
  }
}

export async function recipeHit(
  recipe: {
    recipe: number;
    recipeCategory: number;
  },
  locale?: string,
) {
  try {
    const user = await fetchUser(undefined, locale);
    if (user) {
      return fetchFromVolatileServer(
        `${getServiceURL(locale)}/user/${user.data.id}/recipehit`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(recipe),
        },
      )
        .then((res) => {
          if (!res.ok) {
            console.error(res.status);
            throw new Error("Response not ok");
          }
          return res;
        })
        .catch((err) => {
          console.error(err);
          return null;
        });
    }
  } catch (err) {
    console.error(err);
    // do nothing
  }
}
/* jscpd:ignore-end */
